import { useEffect, useState, useCallback } from 'react'
import { Clock, Search, Award } from 'lucide-react'
import api from '../api/client'
import Loader from '../components/Loader'

const dataBR = (s) => (s ? new Date(s).toLocaleDateString('pt-BR') : '—')
const STATUS_COR = { ativa: 'bg-emerald-100 text-emerald-700', pendente: 'bg-amber-100 text-amber-700' }

export default function TempoCadastro() {
  const [data, setData] = useState([])
  const [q, setQ] = useState('')
  const [loading, setLoading] = useState(true)

  const carregar = useCallback(() => {
    setLoading(true)
    api.get('/licenciados/relatorios/tempo-cadastro' + (q ? `?q=${encodeURIComponent(q)}` : ''))
      .then((r) => setData(r.data.data || [])).catch(() => setData([])).finally(() => setLoading(false))
  }, [q])
  useEffect(() => { const t = setTimeout(carregar, 300); return () => clearTimeout(t) }, [carregar])

  const veteranos = data.filter((d) => (d.tempo?.anos || 0) >= 1).length

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-400 to-violet-500 flex items-center justify-center shadow"><Clock size={20} className="text-white" /></div>
        <div>
          <h1 className="text-2xl font-heading font-bold text-gray-900">Tempo de Cadastro dos Licenciados</h1>
          <p className="text-sm text-gray-500">Acompanhamento de antiguidade da rede e marcos de aniversário (1/3/5/10 anos).</p>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-3 shadow-sm border border-gray-100 flex items-center gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[200px]">
          <Search size={15} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar licenciado..." className="w-full pl-8 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg" />
        </div>
        <span className="text-sm text-gray-500">{data.length} licenciados · <span className="text-amber-600 font-semibold inline-flex items-center gap-1"><Award size={13} /> {veteranos} com 1+ ano</span></span>
      </div>

      {loading ? <div className="flex justify-center py-16"><Loader text="Carregando relatório..." /></div> : (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-x-auto">
          <table className="w-full text-sm whitespace-nowrap">
            <thead className="bg-gray-50 text-gray-500 text-left text-xs uppercase">
              <tr>
                <th className="px-3 py-2">ID</th><th className="px-3 py-2">Nome</th>
                <th className="px-3 py-2">Data de Cadastro</th><th className="px-3 py-2">Tempo</th>
                <th className="px-3 py-2">Status da Licença</th><th className="px-3 py-2">Responsável</th>
              </tr>
            </thead>
            <tbody>
              {data.map((d) => (
                <tr key={d.id} className="border-t border-gray-100 hover:bg-primary-50/30">
                  <td className="px-3 py-2 font-mono text-xs text-gray-400">#{d.id}</td>
                  <td className="px-3 py-2 font-medium text-gray-900">{d.nome}
                    {(d.tempo?.anos || 0) >= 1 && <span className="ml-2 text-[11px] text-amber-500" title="1+ ano de casa">🎉</span>}
                  </td>
                  <td className="px-3 py-2 text-gray-600">{dataBR(d.data_cadastro)}</td>
                  <td className="px-3 py-2 text-gray-700 font-semibold">{d.tempo?.anos}a {d.tempo?.meses}m {d.tempo?.dias}d</td>
                  <td className="px-3 py-2"><span className={`px-2 py-0.5 rounded-full text-[11px] font-bold ${STATUS_COR[d.licenca_status] || 'bg-gray-100 text-gray-600'}`}>{d.licenca_status || '—'}</span></td>
                  <td className="px-3 py-2 text-gray-500">{d.responsavel || '—'}</td>
                </tr>
              ))}
              {data.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-gray-400">Nenhum licenciado encontrado.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
